<template>
    <el-card>
        <el-row class="player-pool__title">个人奖池调控</el-row>
        
        <el-tabs v-model="activeTab" type="card">
            <el-tab-pane label="个人奖池配置" name="config">
                <PlayerPoolConfig />
            </el-tab-pane>
            <el-tab-pane label="个人奖池信息日志" name="infoLog">
                <PlayerPoolInfoLog />
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
import PlayerPoolConfig from './Config.vue'
import PlayerPoolInfoLog from './InfoLog.vue'

export default {
    name: 'PlayerPool',
    components: {
        PlayerPoolConfig,
        PlayerPoolInfoLog
    },
    data() {
        return {
            activeTab: 'config'
        }
    }
}
</script>

<style scoped lang="scss">
.player-pool {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }
}
</style>
